import { call, put, takeLatest } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import api from 'services/api';
import swal from 'sweetalert';

import { Creators as ParticipantsActions, Types as ParticipantsTypes } from 'store/ducks/participants';

function* getParticipantRequest(action) {
  try {
    const { id } = action.payload;
    const url = `prte_person/people/${id}`;
    const response = yield call(api.get, url);

    yield put(ParticipantsActions.getParticipantSuccess(response.data));
  } catch (error) {
    yield call(swal, 'Não encontrado', 'Não encontramos o participante!', 'error');
    yield put(ParticipantsActions.getParticipantFailure());
  }
}

function* getParticipantsRequest(action) {
  try {
    const { page, query } = action.payload;
    const filter = query !== null ? `&filter=${query}` : '';
    const url = `prte_person/people/page?page=${page}&per=25${filter}`;
    const response = yield call(api.get, url);

    yield put(ParticipantsActions.getParticipantsSuccess(response.data));
  } catch (error) {
    yield put(ParticipantsActions.getParticipantsFailure());
  }
}

function* createParticipantRequest(action) {
  try {
    const { data } = action.payload;
    const url = 'prte_person/people';
    yield call(api.post, url, data);

    yield call(swal, 'Succeso', 'Participante criado com sucesso!', 'success');
    yield put(push('/admin/participants'));
    yield put(ParticipantsActions.createParticipantSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível criar o participante!', 'error');
    yield put(ParticipantsActions.createParticipantFailure());
  }
}

function* updateParticipantRequest(action) {
  try {
    const { id, data } = action.payload;
    const url = `prte_person/people/${id}`;
    yield call(api.put, url, data);

    yield call(swal, 'Succeso', 'Participante atualizado com sucesso!', 'success');
    yield put(push('/admin/participants'));
    yield put(ParticipantsActions.updateParticipantSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível atualizar o participante!', 'error');
    yield put(ParticipantsActions.updateParticipantFailure());
  }
}

function* deleteParticipantRequest(action) {
  try {
    const { id } = action.payload;
    const url = `prte_person/people/${id}`;
    yield call(api.delete, url);

    yield call(swal, 'Succeso', 'Participante removido com sucesso!', 'success');
    yield put(ParticipantsActions.getParticipantsRequest(1));
    yield put(ParticipantsActions.deleteParticipantSuccess());
  } catch (error) {
    yield call(swal, 'Ops, Falha', 'Não foi possível remover o participante!', 'error');
    yield put(ParticipantsActions.deleteParticipantFailure());
  }
}

function* searchParticipantsByDocumentRequest(action) {
  try {
    const { search } = action.payload;
    const url = `prte_person/people`;
    const response = yield call(api.get, url, { params: { search } });

    yield put(ParticipantsActions.searchParticipantsByDocumentSuccess(response.data));
  } catch (error) {
    yield put(ParticipantsActions.searchParticipantsByDocumentFailure());
  }
}

export default function* saga() {
  yield takeLatest(ParticipantsTypes.GET_REQUEST, getParticipantRequest);
  yield takeLatest(ParticipantsTypes.GET_LIST_REQUEST, getParticipantsRequest);
  yield takeLatest(ParticipantsTypes.CREATE_REQUEST, createParticipantRequest);
  yield takeLatest(ParticipantsTypes.UPDATE_REQUEST, updateParticipantRequest);
  yield takeLatest(ParticipantsTypes.DELETE_REQUEST, deleteParticipantRequest);
  yield takeLatest(ParticipantsTypes.SEARCH_BY_DOCUMENT_REQUEST, searchParticipantsByDocumentRequest);
}



// WEBPACK FOOTER //
// ./src/store/sagas/participants.js